import createAuth0Client from "@auth0/auth0-spa-js";

export const initAuthoClient = async () => {
  const auth0Client = await createAuth0Client({
    domain: process.env.AUTH0DOMAIN,
    client_id: process.env.AUTH0CLIENTID,
    redirect_uri: window.location.origin,
    audience: process.env.AUTH0AUDIENCE
  });
  return auth0Client;
};
